(() => {
  const body = document.body;
  if (!body?.hasAttribute('data-floating-widget-rail')) return;

  const smileSelector = '#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container';
  const stickySelector = 'product-add-to-cart-sticky';
  let launcher = null;
  let sticky = null;
  let frame = 0;
  let previousHeight = -1;
  let previousScale = -1;

  function onStickyTransition(event) {
    if (event.target === sticky && event.propertyName === 'transform') scheduleMeasure();
  }

  const resizeObserver = new ResizeObserver(() => scheduleMeasure());

  function observe(node, previous) {
    if (node === previous) return previous;
    if (previous) {
      resizeObserver.unobserve(previous);
      if (previous.matches(stickySelector)) {
        previous.removeEventListener('transitionend', onStickyTransition);
        previous.removeEventListener('transitioncancel', onStickyTransition);
      }
    }
    if (node) {
      resizeObserver.observe(node);
      if (node.matches(stickySelector)) {
        node.addEventListener('transitionend', onStickyTransition);
        node.addEventListener('transitioncancel', onStickyTransition);
      }
    }
    return node;
  }

  function measure() {
    frame = 0;
    launcher = observe(document.querySelector(smileSelector), launcher);
    sticky = observe(document.querySelector(stickySelector), sticky);

    const target = parseFloat(getComputedStyle(body).getPropertyValue('--floating-widget-size')) || 60;
    const nativeHeight = launcher?.offsetHeight || 0;
    // Smile's mobile launcher is 44px; scale up as well as down to match the rail.
    const scale = nativeHeight > 0 ? target / nativeHeight : 1;
    if (scale !== previousScale) {
      body.style.setProperty('--floating-rewards-scale', String(scale));
      previousScale = scale;
    }

    // Reserve the final footprint from layout dimensions: a transform changes
    // the rect during entry without changing offsetHeight or firing resize.
    let height = 0;
    if (sticky?.isConnected) {
      const rect = sticky.getBoundingClientRect();
      const style = getComputedStyle(sticky);
      const visible = sticky.classList.contains('sticky--visible');
      const onScreen = rect.bottom > 0 && rect.top < innerHeight;
      if (style.display !== 'none' &&
          rect.width > 0 && rect.right > 0 && rect.left < document.documentElement.clientWidth &&
          (visible || (style.visibility !== 'hidden' && Number(style.opacity) > 0 && onScreen))) {
        const bottom = parseFloat(style.bottom);
        height = Number.isFinite(bottom)
          ? Math.max(0, sticky.offsetHeight + bottom + (parseFloat(style.marginBottom) || 0),
              onScreen ? innerHeight - rect.top : 0)
          : Math.max(0, innerHeight - rect.top);
      }
    }
    if (height !== previousHeight) {
      body.style.setProperty('--floating-sticky-atc-height', `${height}px`);
      previousHeight = height;
    }
  }

  function scheduleMeasure() {
    if (!frame) frame = requestAnimationFrame(measure);
  }

  const mutationObserver = new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') {
        if (record.target.matches(stickySelector)) scheduleMeasure();
        continue;
      }
      const changed = [...record.addedNodes, ...record.removedNodes].some(node =>
        node.nodeType === Node.ELEMENT_NODE &&
        (node.matches(smileSelector) || node.matches(stickySelector) ||
         node.querySelector(smileSelector) || node.querySelector(stickySelector)));
      if (changed) { scheduleMeasure(); break; }
    }
  });

  mutationObserver.observe(body, { childList: true, subtree: true, attributes: true,
    attributeFilter: ['class'] });
  window.addEventListener('resize', scheduleMeasure);
  window.addEventListener('scroll', scheduleMeasure, { passive: true });
  measure();

  window.addEventListener('pagehide', (event) => {
    if (event.persisted) return;
    mutationObserver.disconnect();
    resizeObserver.disconnect();
    if (sticky) {
      sticky.removeEventListener('transitionend', onStickyTransition);
      sticky.removeEventListener('transitioncancel', onStickyTransition);
    }
    window.removeEventListener('resize', scheduleMeasure);
    window.removeEventListener('scroll', scheduleMeasure);
    if (frame) cancelAnimationFrame(frame);
  });
})();
